export default "__VITE_ASSET__CB_HqYa0__"